import moment from "moment";
import { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import swal from "sweetalert2";
import useKeyboardShortcut from "use-keyboard-shortcut";
import {
  allSites,
  columnsBank,
  columnsCash,
  columnsJournal,
  getMonthYearFromDate,
  userDetail,
  voucherIndex
} from "../../../utils/Level/utils";
// import { NavBar } from 'app/components/NavBar';
import { Typography } from "@mui/material";
import { DataGrid } from "@mui/x-data-grid";
import Swal from "sweetalert2";
import { getVoucherIndex } from "../../../api/restApi";
import Loader from "../../../components/Accounts/Loader";
import Report from "../../../components/Accounts/Reports/report";
import BPVoucher from "../../../components/Accounts/Voucher/BPVoucher";
import DialogVoucherSearch from "../../../components/Accounts/Voucher/dialogVoucherSearch";
import VoucherBar from "../../../components/Accounts/Voucher/voucherbar";
import VoucherHeader from "../../../components/Accounts/Voucher/voucherheader";
import { tableCellStyle } from "../../../styles";
import {
  deleteVoucher,
  getSpecificVoucher,
  updateVoucher,
} from "../../../utils/endPoints";
import { useAppSelector } from "../../../utils/hooks";

function SearchVoucher(props) {
  const { state } = useLocation();
  const inputVoucher = state;
  const navigate = useNavigate();
  const classes = tableCellStyle();
  const user = userDetail;
  const [showEntryForm, setShowEntryForm] = useState(false);
  const [showSearch, setShowSearch] = useState(false);
  const [filteredDataSource, setFilteredDataSource] = useState([]);
  const [type, setType] = useState(inputVoucher.vtype);
  const [date, setDate] = useState(moment(inputVoucher.vdate, "DD/MM/YYYY"));
  const [isEdit, setIsEdit] = useState(false);
  const [voucherCurrentIndex, setVoucherCurrentIndex] = useState(
    inputVoucher.vindex
  );
  const [maxIndex, setMaxIndex] = useState(parseInt(inputVoucher.vindex));
  const [voucher, setVoucher] = useState({
    voucherRecBy: "",
    voucherDepBy: "",
    invoiceBillNum: "",
    description: "",
    balance: "",
    type: type,
    voucherItems: [],
    voucherDate: moment(inputVoucher.vdate, "DD/MM/YYYY"),
    lockStatus: false,
  });

  const [creditTotal, setCreditTotal] = useState(0);
  const [debitTotal, setDebitTotal] = useState(0);
  const [difference, setDifferene] = useState(0);
  const [level3Codes, setLevel3Codes] = useState([]);
  const [rowData, setRowData] = useState();
  const [level3CodesFiltered, setLevel3CodesFiltered] = useState([]);
  const [vmode, setVMode] = useState("find");
  const [title, setTitle] = useState("Find Voucher");
  const [editIndex, setEditIndex] = useState(true);
  const [findIndex, setFindIndex] = useState(parseInt(inputVoucher.vindex));
  const [columns, setColumns] = useState(columnsBank);
  const [loading, setLoading] = useState(false);
  const [originalVoucher, setOriginalVoucher] = useState({});
  const [voucherPrintData, setVoucherPrintData] = useState({});
  const VoucherData = useAppSelector((state) => state.accountLevels.level3);
  const [sites, setSites] = useState(allSites);
  const [site, setSite] = useState(sites[0]?.id);
  const [open, setOpen] = useState(false);
  const handleOpen = () => setOpen(true);

  const handleClose = () => {
    setVoucherPrintData({});
    setOpen(false);
  };

  const changeMode = () => {
    navigate("/voucher", { replace: true });
  };

  const cancelCallback = () => {
    changeMode();
  };

  const handlePre = () => {
    if (findIndex > 1) {
      setFindIndex(findIndex - 1);
    }
    setVoucher({
      ...voucher,
      voucherRecBy: "",
      voucherDepBy: "",
      invoiceBillNum: "",
      description: "",
      balance: "",
      voucherItems: [],
      lockStatus: false,
    });
    setDifferene(0);
    setDebitTotal(0);
    setCreditTotal(0);
    setLoading(false);
    setFilteredDataSource([]);
  };
  const getVIndex = async () => {
    const { value: vnumber } = await swal.fire({
      title: "Enter Voucher Number",
      input: "number",
      inputValue: findIndex,
      showCancelButton: true,
      inputValidator: (value) => {
        if (!value) {
          return "You need to enter Voucher#";
        } else if (value > maxIndex) {
          let temp = maxIndex + 1;
          return "Voucher # should be less than  " + temp;
        } else if (value < 1) {
          let temp = maxIndex + 1;
          return "Voucher # should be greater than  0";
        }
      },
    });
    if (vnumber) {
      setFindIndex(parseInt(vnumber));
    }
  };

  const handleNext = () => {
    if (findIndex + 1 <= maxIndex) {
      setFindIndex(findIndex + 1);
      setVoucher({
        ...voucher,
        voucherRecBy: "",
        voucherDepBy: "",
        invoiceBillNum: "",
        description: "",
        balance: "",
        voucherItems: [],
        lockStatus: false,
      });
      setDifferene(0);
      setDebitTotal(0);
      setCreditTotal(0);
      setLoading(false);
      setFilteredDataSource([]);
    }
  };

  const updatePrintData = () => {
    let sitename = "";
    sites.forEach((element) => {
      if (element.id == site) {
        sitename = element.name;
      }
    });
    let voucherObject = {
      id: "617fb229f661460020535df3",
      invoice: filteredDataSource,
      titleData: {
        heading: user?.companyname,
        site: sitename,
        title: "Voucher",
        subTitle: "Date: " + date.format("DD/MM/YYYY"),
        leftTitle: "",
        leftSubTitle: "",
        rightTitle: "",
        rightSubTitle: "",
      },
      subTitleData: {
        type: type,
        number: findIndex,
        description: originalVoucher.description,
      },
      docTitle: "",
      docType: "Voucher",
      from: "",
      to: "",
      codeDetails: {},
      totalDebit: debitTotal,
      totalCredit: creditTotal,
      balance: 0,
      openingBalance: 0,
    };
    console.log(voucherObject);
    setVoucherPrintData(voucherObject);
  };

  async function updateLevel3Data(event, params) {
    console.log(params);
    setIsEdit(true);
    setRowData({
      newcode: params.row.code,
      defaultDescription: params.row.Discription,
      defaultAmount: params.row.amount,
      defaultTransactionType: params.row.transaction,
      // name: defaultName,
      // contact: defaultContact,
      // address: defaultAddress,
    });
    // setUpdateLevel3(true);
    // setName("");
    // setContact("");
    // setAddress("");
    // setCode(params.row.code);
    // setDescription(params.row.description);
    // setType(params.row.type);
    // if (params.row.name) {
    //   setName(params.row.name);
    //   setContact(params.row.contact);
    //   setAddress(params.row.address);
    // }

    // let OldValue = freeze;
    // if (params.row.freeze == "NO") {
    //   setFreeze(false);
    // } else {
    //   setFreeze(true);
    // }
    setShowEntryForm(true);
  }

  //call back for advance search
  const searchCallback = async (findData) => {
    setDate(moment(findData.voucherDate, "DD/MM/YYYY"));
    setType(findData.type);
    setFindIndex(findData.voucherNumber);
    setLoading(true);
    let currentDate =
      findData.voucherDate.split("-")[1] +
      "-" +
      findData.voucherDate.split("-")[2];
    console.log(currentDate);
    const currentVocuher = await getSpecificVoucher(
      currentDate,
      findData.type,
      findData.voucherNumber
    );
    console.log(currentVocuher, " Find");
    setFilteredDataSource([]);
    if (currentVocuher) {
      setDate(moment(currentVocuher.voucherDate, "DD/MM/YYYY"));
      setOriginalVoucher({ ...originalVoucher, ...currentVocuher });
      setFilteredDataSource(currentVocuher.voucherItemsData);
      let tempVoucher = {
        ...currentVocuher,
      };
      tempVoucher = {
        ...tempVoucher,
        voucherItems: tempVoucher["voucherItemsData"],
      };
      delete tempVoucher["voucherItemsData"];
      setVoucher(tempVoucher);
    }
    setLoading(false);
  };

  const updateLevel3DataQuery = (data) => {
    console.log(data);
    // let codeArray = data.level3Code.split("-");
    setShowEntryForm(false);
    Swal.fire({
      title: "Are you sure to update existing code?",
      text: "You won't be able to revert this!",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Yes, update it!",
    }).then(async (result) => {
      if (result.value) {
        updateVoucherItem(data);
        if (data.freeze) {
          data.freeze = "YES";
        } else {
          data.freeze = "NO";
        }
        setFilteredDataSource(
          filteredDataSource.map((item) => {
            if (item.code === data.code) {
              return {
                ...item,
                amount: data.amount,
                transaction: data.transaction,
                transactionType: data.transactionType,
                credit: data.credit,
                debit: data.debit,
                Discription: data.Discription,
              };
            }
            return item;
          })
        );
      }
    });
    return;
  };

  async function findCallback() {
    setLoading(true);
    let ind = parseInt(voucherCurrentIndex) - 1;
    let searchIndex;
    if (vmode == "new") {
      if (ind == 0) {
        ind = 1;
      }
      searchIndex = ind;
      setFindIndex(searchIndex);
      console.log("Search voucher index is ", searchIndex);
      setEditIndex(true);
      setVMode("find");
    } else {
      searchIndex = findIndex;
      console.log("Search voucher index is ", searchIndex);
    }

    let currentDate = getMonthYearFromDate(moment(date).format("DD/MM/YYYY"));
    const currentVocuher = await getSpecificVoucher(
      currentDate,
      type,
      searchIndex
    );
    console.log(currentVocuher, " test");
    setFilteredDataSource([]);
    if (currentVocuher) {
      console.log();
      setDate(moment(currentVocuher.voucherDate, "DD/MM/YYYY"));
      setOriginalVoucher({ ...originalVoucher, ...currentVocuher });
      setFilteredDataSource(currentVocuher.voucherItemsData);

      let tempVoucher = {
        ...currentVocuher,
      };

      tempVoucher = {
        ...tempVoucher,
        voucherItems: tempVoucher["voucherItemsData"],
      };
      delete tempVoucher["voucherItemsData"];
      setVoucher(tempVoucher);
    }
    setLoading(false);
  }
  useKeyboardShortcut(["F1"], () => addNewVoucher(), {
    overrideSystem: true,
  });
  function addNewVoucher() {
    setShowEntryForm(true);
  }

  useKeyboardShortcut(["F2"], () => dialogSearch(), {
    overrideSystem: true,
  });
  function dialogSearch() {
    console.log("F2 pressed");
    setShowSearch(true);
  }

  async function typeChange(type) {
    setType(type);
    setTimeout(function () {
      setLoading(true);
    }, 500);
    // ;
    setVoucher({ ...voucher, type });
    resetVoucher(moment(date).format("DD/MM/YYYY"), type);
    setLoading(false);
  }
  async function dateChange(dateInput) {
    // const voucherDate = new Date(dateInput);
    // setDate(voucherDate);
    setDate(moment(dateInput));
    setTimeout(function () {
      setLoading(true);
    }, 500);
    resetVoucher(moment(dateInput).format("DD/MM/YYYY"), voucher.type);
    setVoucher({ ...voucher, voucherDate: date });
    findCallback();
    // setLoading(false);
  }
  async function printCallback() {
    updatePrintData();
    handleOpen();
  }

  const deleteCallback = async () => {
    console.log("Voucher Delete Button Presses!... ");
    voucher.type = type;
    voucher.voucherDate = date;
    Swal.fire({
      title: "Are you sure to Delete this Voucher?",
      text: "You won't be able to revert this!",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Yes, Delete it!",
    }).then(async (result) => {
      if (result.isConfirmed) {
        if (filteredDataSource.length == 0) {
          toast.error("Voucher is empty!");
        } else if (difference == "0") {
          setTimeout(function () {
            setLoading(true);
          }, 500);

          const result = await deleteVoucher(type, voucher, findIndex);
          console.log("result value: ", result);
          resetVoucher(moment(date).format("DD/MM/YYYY"), voucher.type);
          toast.success("Voucher deleted successfully!");
        } else if (difference != "0") {
          toast.error("Total Debit and Total Credit must be equall!");
        }
      }
    });
  };
  async function saveCallback() {
    voucher.type = type;
    voucher.voucherDate = date;

    if (filteredDataSource.length == 0) {
      toast.error("Voucher is empty!");
    } else if (difference == "0") {
      Swal.fire({
        title: "Are you sure to Update Voucher?",
        text: "You won't be able to revert this!",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Yes, Update it!",
      }).then(async (res) => {
        if (res.isConfirmed) {
          const result = await updateVoucher(type, date, voucher, findIndex);
          console.log("result value: ", date);
          resetVoucher(moment(date).format("DD/MM/YYYY"), voucher.type);
          toast.success("Voucher Updated successfully!");
        }
      });
    } else if (difference != "0") {
      toast.error("Total Debit and Total Credit must be equall!");
    }
  }
  async function resetVoucher(voucherDate, typeInput) {
    const index = await voucherIndex(voucherDate, typeInput);
    setVoucherCurrentIndex(index);
    if (index == 1) {
      setFindIndex(index);
    } else {
      setFindIndex(index - 1);
    }

    setVoucher({
      ...voucher,
      voucherRecBy: "",
      voucherDepBy: "",
      invoiceBillNum: "",
      description: "",
      balance: "",
      voucherItems: [],
      lockStatus: false,
    });
    setDifferene(0);
    setDebitTotal(0);
    setCreditTotal(0);
    setLoading(false);
    setFilteredDataSource([]);
  }
  function addVocuherItem(data) {
    var vouch = { ...voucher };
    vouch = { ...vouch, voucherItems: [...vouch.voucherItems, data] };
    setVoucher(vouch);
  }

  const updateVoucherItem = (data) => {
    var vouch = { ...voucher };
    console.log(vouch);

    let vouchItems = vouch.voucherItems.map((item) => {
      if (item.code === data.code && item.type === data.type) {
        item.amount = data.amount;
        item.Discription = data.Discription;
        data.transactionType === "Credit"
          ? (item.credit = data.credit)
          : (item.debit = data.debit);
      }
      return item;
    });

    console.log(vouchItems);

    vouch = { ...vouch, voucherItems: [...vouchItems] };
    setVoucher(vouch);
  };

  async function getAllLevel3(companyid) {
    setLevel3Codes([]);
    setLevel3Codes(VoucherData);
    setLevel3CodesFiltered(VoucherData.filter((x) => x.type === "BANK"));
  }

  useEffect(() => {
    console.log(voucherPrintData);
    if (voucherPrintData?.titleData?.heading) {
      handleOpen();
    }
  }, [voucherPrintData]);

  useEffect(() => {
    if (vmode == "new") {
      setTitle("New Voucher");
    } else {
      setTitle("Find Voucher");
    }
  }, [vmode]);

  const updateVoucherData = async () => {
    let currentDate = getMonthYearFromDate(date.format("DD/MM/YYYY"));
    console.log(currentDate);

    let VoucherIndex = await getVoucherIndex(currentDate, type);
    console.log(VoucherIndex.date);
    setVoucherCurrentIndex(VoucherIndex?.date?.id);
  };

  useEffect(() => {
    findCallback();
    getAllLevel3(user.companyid);
  }, [findIndex]);

  useEffect(() => {
    // updateVoucherData();
    if (type == "BRV" || type == "BPV") {
      setColumns(columnsBank);
      setLevel3CodesFiltered(level3Codes?.filter((x) => x.type === "BANK"));
    } else if (type == "CPV" || type == "CRV") {
      setColumns(columnsCash);
      setLevel3CodesFiltered(level3Codes.filter((x) => x.type === "CASH"));
    } else {
      setLevel3CodesFiltered(
        level3Codes.filter((x) => x.type !== "BANK" && x.type !== "CASH")
      );

      setColumns(columnsJournal);
    }
  }, [type, date, level3Codes]);

  useEffect(() => {
    let creditTemp = 0;
    let debitTemp = 0;

    filteredDataSource.forEach(function (arrayItem) {
      var x = arrayItem?.debit;
      var y = arrayItem?.credit;
      if (x != "") {
        const parsed = parseInt(x);
        debitTemp += parsed;
      } else {
        const parsed = parseInt(y);
        creditTemp += parsed;
      }
    });

    setCreditTotal(creditTemp);
    setDebitTotal(debitTemp);
    setDifferene(Math.abs(creditTemp - debitTemp));
    setVoucherPrintData({ ...voucherPrintData, invoice: filteredDataSource });
  }, [filteredDataSource]);

  const processCallback = (data) => {};

  return (
    <div>
      <Loader loading={loading} />
      <div
        style={{
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          marginTop: "1rem",
          justifyContent: "center",
          // backgroundColor: '#5CDB95',
        }}
      >
        <ToastContainer
          position="bottom-center"
          autoClose={2000}
          hideProgressBar={true}
          closeOnClick={true}
          progress={undefined}
        />
        {showEntryForm ? (
          <BPVoucher
            okCallback={(data) => {
              const currentId = filteredDataSource.length + 1;
              data = { ...data, id: currentId, site: site };
              setShowEntryForm(false);
              setFilteredDataSource((filteredDataSource) => [
                ...filteredDataSource,
                data,
              ]);
              addVocuherItem(data);
            }}
            cancelCallback={() => {
              setShowEntryForm(false);
            }}
            updateCallback={(data) => {
              updateLevel3DataQuery(data);
              setIsEdit(false);
            }}
            level3Codes={level3Codes}
            level3CodesFiltered={level3CodesFiltered}
            vtype={type}
            visible={showEntryForm}
            voucherRowData={rowData}
            isEdit={isEdit}
          ></BPVoucher>
        ) : (
          <></>
        )}
        {/* For advance search start*/}
        {showSearch ? (
          <DialogVoucherSearch
            okCallback={(data) => {
              console.log(data);
              searchCallback(data);
              setShowSearch(false);
            }}
            cancelCallback={() => {
              setShowSearch(false);
            }}
            level3Codes={level3Codes}
            level3CodesFiltered={level3CodesFiltered}
            vtype={type}
            visible={showSearch}
          ></DialogVoucherSearch>
        ) : (
          <></>
        )}
        {/* For advance search end*/}
        {/* <NavBar /> */}
        {/* <CompanyAppBar></CompanyAppBar> */}
        <Typography variant="h4" component="h2" gutterBottom>
          {title}
        </Typography>

        <div
          style={{
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            justifyContent: "center",
            width: "95%",
            height: "80vh",
            // backgroundColor: '#379683',
          }}
          className={classes.root}
        >
          <DataGrid
            headerHeight={20}
            rowHeight={25}
            style={{ width: "100%" }}
            onCellDoubleClick={(params, event) => {
              updateLevel3Data(event, params);
            }}
            rows={filteredDataSource}
            // getRowId={(filteredDataSource) => filteredDataSource.id}
            columns={columns}
            pageSize={25}
            disableColumnMenu
            components={{
              Footer: VoucherBar,
              Toolbar: VoucherHeader,
            }}
            componentsProps={{
              toolbar: {
                typeChange,
                dateChange,
                type,
                site,
                date,
                voucher,
                setVoucher,
                voucherCurrentIndex,
                editIndex,
                setFindIndex,
                findIndex,
                getVIndex,
              },
              footer: {
                deleteCallback,
                saveCallback,
                printCallback,
                debitTotal,
                creditTotal,
                difference,
                findCallback,
                cancelCallback,
                changeMode,
                handlePre,
                handleNext,
                editIndex,
              },
            }}
          />
        </div>
      </div>
      <Report open={open} handleClose={handleClose} data={voucherPrintData} />
    </div>
  );
}

export default SearchVoucher;
